import { environment } from "src/environments/environment"

export const COLUMNA_PRINCIPAL = 'col-12 col-sm-6 col-md-6 col-lg-7'
export const COLUMNA_SECUNDARIA = 'col-12 col-sm-6 col-md-6 col-lg-5'
export const SISTEMA_EXTRANET = 2

// URL de desrvicios
export const URL_MEDIA = 'assets'  //'/issys-media/issys-media/issys-framework'

/** endpoints para login y sesion */
export const URL_ACCESO = '/Acceso-backend';
export const URL_INICIO = '/ingreso/';
export const URL_Login = URL_ACCESO+'/login'
export const URL_Refresh_tocken = URL_ACCESO+'/refresh'
export const URL_session = URL_ACCESO+'/session'
export const URL_ISSYSMEDIA="/issys-media/cabecera/newHeaderExtranet.js"


/** endpoints propios de la aplicaci{on} */

/** Dirección del frontend */
export const URL_BASE = 'http://localhost:4200/'//'/acceso-frontend'

/** Direcciones del backend con el que se comunica */
export const URL_APP = '/ConsultasPublicas'
export const URL_ENDPOINT = URL_APP+'/sesion'


